<div *ngIf="errors.length">
    <div *ngFor="let error of errors" class="mb-4">
        <span class="badge" translate>admin.field</span>
        <div class="font-medium">{{ error.propertyName }}</div>
        <div>{{ error.errorMessage }}</div>
    </div>
</div>
<div *ngIf="!errors.length">
    {{ 'admin.everything-configured' | translate }}
</div>
